import { render, staticRenderFns } from "./auth_liff.vue?vue&type=template&id=4e527934&scoped=true&"
import script from "./auth_liff.vue?vue&type=script&lang=js&"
export * from "./auth_liff.vue?vue&type=script&lang=js&"
import style0 from "./auth_liff.vue?vue&type=style&index=0&id=4e527934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e527934",
  null
  
)

export default component.exports